export const validateEmail = (val) => {
  if (!val || val.length < 1) { return 'Invalid E-mail address.' }
  if (!/^(?=[a-zA-Z0-9@._%+-]{6,254}$)[a-zA-Z0-9._%+-]{1,64}@(?:[a-zA-Z0-9-]{1,63}\.){1,8}[a-zA-Z]{2,63}$/.test(val)) { return 'E-mail not valid.' }
}
export const required = (val) => {
  if (!val || val.length < 1) { return 'Dies ist ein Pflichtfeld.' }
}
